import { GetOffersResult } from '@west-australian-newspapers/subscription-offer-types'
import { Logger } from '@west-australian-newspapers/typescript-log'
import React from 'react'
import { transformOffersResultToPackageOption } from '../../subscription-offers/SubscriptionOffers'
import { ISingleSubscriptionPackage } from '../../user-registration/breach/helpers/BreachWallTypes'
import {
    DescriptionText,
    GoogleOfferListContainer,
    SemiboldText,
    StyledInstructionsTitle,
    StyledSubheading,
    StyledSubscriptionCopyArea,
    StyledSubscriptionCopyTitle,
    StyledTextLink,
    UniOfferInstructionsDescription,
} from '../RegionalsSwgPromoPage/RegionalsSwgPromoPage.styled'
import { SwgCampaignOfferValues } from '../campaigns'

export const getIntro25OfferRrmeCampaignValues = (
    log: Logger,
    apiOffers?: GetOffersResult,
): SwgCampaignOfferValues | undefined => {
    const campaignOffers = transformOffersResultToPackageOption(
        'campaigns',
        apiOffers,
    )
    // We need to check if campaignOffers has the expected key and if it has at least one offer
    // if it doesn't, log a warning as a result of multiple calls and the initial call not having completed yet.
    // The last render will always have at least one offer.
    let intro25Offer: ISingleSubscriptionPackage | undefined
    if (
        campaignOffers['intro-25-offer'] &&
        campaignOffers['intro-25-offer'].length > 0
    ) {
        intro25Offer = campaignOffers[
            'intro-25-offer'
        ][0] as ISingleSubscriptionPackage
    }
    if (!intro25Offer?.googleSKU || intro25Offer.weeklyPrice === undefined) {
        return undefined
    }

    return {
        isDefault: false,
        creative: 'TW_Subscribe_With_Google_Campaign',
        deal: 'swg-promo',
        type: 'Premium - Inline',
        sku: intro25Offer.googleSKU,
        price: {
            weekly: intro25Offer.weeklyPrice,
            originalPrice: intro25Offer.originalPrice,
            promoPrice: intro25Offer.price,
            billingTerms: intro25Offer.cancellationMessage,
        },
        BenefitListComponent: (
            <>
                <StyledInstructionsTitle>
                    Enjoy full digital access
                </StyledInstructionsTitle>
                <StyledSubheading>
                    25% OFF your first four weeks.
                </StyledSubheading>
                <UniOfferInstructionsDescription>
                    Your introductory offer gives you access to everything on
                    thewest.com.au, including:
                </UniOfferInstructionsDescription>
                <GoogleOfferListContainer>
                    <li>Breaking local, state and national news;</li>
                    <li>WA’s most experienced journalists and columnists;</li>
                    <li>
                        In-depth analysis of WA Business, Politics, Sports &
                        more;
                    </li>
                    <li>Daily digital edition of The West;</li>
                    <li>
                        Subscriber exclusive newsletters & video content; and
                    </li>
                    <li>Access to download The West App.</li>
                </GoogleOfferListContainer>
                <DescriptionText>
                    Plus, link your subscription to your Google account for fast
                    and easy access to The West content across Google.
                </DescriptionText>
            </>
        ),
        TermsAndConditionsComponent: (
            <StyledSubscriptionCopyArea>
                <StyledSubscriptionCopyTitle>
                    <SemiboldText>
                        Subscribe with Google – Intro Offer Subscription Terms.
                    </SemiboldText>
                </StyledSubscriptionCopyTitle>
                With this subscription offer, valid from 01.04.26 to 31.05.26,
                your subscription will be charged at $6.00 per week for the
                first four weeks. After your first four weeks, your subscription
                will be charged at the full price of $8.00 per week. To be
                eligible for this offer you must: (a) be a new subscriber; (b)
                have devices that meet the following minimum technical
                requirements: iOS requirement of 16.0 and Android minimum
                requirement of 7.0. Offers are subject to our standard{' '}
                <StyledTextLink
                    href={
                        'https://subscriber.thewest.com.au/subscription-terms'
                    }
                >
                    Subscription Terms and Conditions
                </StyledTextLink>{' '}
                and the standard{' '}
                <StyledTextLink
                    href={
                        'https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&ldt=googlepaytos&ldl=en-GB'
                    }
                >
                    Subscribe with Google Terms.
                </StyledTextLink>{' '}
                Payment is by Direct Debit at 4-week intervals in accordance
                with our Direct Debit Agreement, with the first payment payable
                on day 1 of your subscription term. See{' '}
                <StyledTextLink
                    href={
                        'https://subscriber.thewest.com.au/subscribe-with-google-faq'
                    }
                >
                    Subscribe with Google with Google FAQs.
                </StyledTextLink>
            </StyledSubscriptionCopyArea>
        ),
        InfoComponent: () => <></>,
    }
}
